export default __webpack_public_path__ + "static/media/linkedin.da64d11e.svg";